<template>
  <div class="row align-items-center bg-light mb-2 py-3 rounded" v-if="index != 'toplam_sure'">
    <div class="col-12">
      <!-- Refactoring -->
      <div class="card card-fill question-card mb-0 shadow-sm m-3">
        <div class="card-header">
          <div class="row align-items-center">
            <div class="col-12 col-lg-8 text-center">
              <small>
              </small>
            </div>
            <div class="container">
              <div class="row justify-content-between">
                <div class="col-12 col-lg-4">
                  <div class="btn-group my-2">
                    <a href="javascript:;" class="btn btn-sm btn-white ml-3" data-balloon-pos="up" :aria-label="'Soru ID: '+q.random_soru_id">
                      <i class="fe fe-help-circle"></i> {{ (parseInt(index) + 1) }}. Soru
                    </a>
                  </div>
                </div>
                <div class="col-12 col-lg-4">
                  <div class="btn-group float-right my-2">
                    <a href="javascript:;" @click="draw_area[index].clear();" class="btn btn-sm btn-white ml-3" data-balloon-pos="up" aria-label="Çizim Alanını Temizle">
                      <i class="fe fe-edit-3"></i>
                    </a>
                    <a @click="downloadAsImage(index);" href="javascript:;" class="btn btn-sm btn-white" data-balloon-pos="up" aria-label="Çizimi Bilgisayara Kaydet">
                      <i class="fe fe-download"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a :ref="'img' + index" :id="'img' + index" class="canvas_area">
          <canvas :id="'canvas' + index" :ref="'canvas' + index">
          </canvas>
          <img class="card-img-top question_img img-fluid" :title="q.soru_resim ? '' : 'Soru görseli bulunamadı!'" :src="q.soru_resim ? q.soru_resim : '/assets/img/illustrations/qlost.svg'" :alt="q.random_soru_id + '. Soru Resmi'" />
        </a>
        <div class="card-body mt-0">
          <div class="row align-items-center">
            <div class="col-12">
              <div class="btn-group d-flex">
                <button 
                  :key="i" v-for="(answer_name, i) in ['A', 'B', 'C', 'D']"
                  :disabled="end"
                  class="btn btn-default nav-justified" :class="answerButtonClass(answer_name)"
                  @click="answerSend(answer_name)">
                  <i :class="answerControl(answer_name) ? 'fe-stop-circle' : 'fe-circle'" class="fe"></i> {{ answer_name }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from '@/helpers/http'
import base from '@/mixins/base' // eslint-disable-line
// import { Base64 } from 'js-base64';

export default {
  name: 'Quiz',
  props: ['question', 'index', 'end', 'qkey'],
  data() {
    return {
      q: null,
      answer: null,
      temp_answer: null,
      draw_area: [],
    }
  },
  methods: {
    answerButtonClass(thisAnswer) {

      let ret = 'btn-white'

      if (this.end || this.answer === this.temp_answer) {
        if (thisAnswer === this.keyReturn() && this.answer === thisAnswer) {
          ret = 'btn-success'
        } /*else if(thisAnswer === this.keyReturn() && this.answer !== thisAnswer) {
          ret = 'btn-info'
        } */else if(this.answer !== null && thisAnswer === this.answer) {
          ret = 'btn-danger'
        }

      } else {
        if (this.answer === thisAnswer) {
          ret = 'btn-primary'
        } else if (this.answer === undefined && this.temp_answer === thisAnswer) {
          ret = 'btn-primary'
        }
      }

      return ret

    },
    test(t) { // eslint-disable-line
      return t === this.keyReturn ? '.' : '';
    },
    keyReturn() {
      switch (this.q.soru_cevap) {
        case '7fc56270e7a70fa81a5935b72eacbe29':
          return 'A';
        
        case '9d5ed678fe57bcca610140957afab571':
          return 'B';
        
        case '0d61f8370cad1d412f80b84d143e1257':
          return 'C';
        
        case 'f623e75af30e62bbd73d6df5b50bb7b5':
          return 'D';
        
        case '3a3ea00cfc35332cedf6e5e9a32e94da':
          return 'E';
      }
      return null // Base64.decode(this.q.soru_cevap)
    },
    answerControl(answer) {

      return answer === this.answer ? true : false
    },
    downloadAsImage(id) {

      function download(filename, text) {
        var element = document.createElement('a');
        element.setAttribute('href', text);
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      }
      const dataURL = this.draw_area[id].toImage()
      download('kisa_sinav_calisma_alani_' + (new Date().toLocaleDateString()) + '.png', dataURL)
    },
    answerSend(a) {

      if (! this.end) {
        this.answer = a
        http.post('cevap-kaydet', {
          ogrenciID: this.$store.state.auth.student_id,
          quizID: this.q.quiz_id,
          cevap: this.answer
        }).then(response => {
          if (response.data !== undefined && response.data) {
            let save = []
            if (localStorage.getItem(this.qkey + '_answers')) {
              save = JSON.parse(localStorage.getItem(this.qkey + '_answers'))
            }
            
            save[this.index] = this.answer
            localStorage.setItem(this.qkey + '_answers', JSON.stringify(save))
          } else {
            $.confirm({ // eslint-disable-line
              title: 'Cevap Kaydetme Sorunu',
              content: 'Cevabınızı kaydederken bir sorunla karşılaştık.',
              type: 'red',
              typeAnimated: true,
              buttons: {
                kapat: {
                },
              }
            })
          }
        }).catch(error => {

          $.confirm({ // eslint-disable-line
            title: 'Cevap Kaydetme Sorunu',
            content: 'Cevabınızı kaydederken bir sorunla karşılaştık.',
            type: 'red',
            typeAnimated: true,
            backgroundDismissAnimation: 'glow',
            buttons: {
              test: {
                isHidden: true,
                isDisabled: true,
              },
            }
          })
          throw error;
        });
      }
    }
  },
  created() {
    this.q = this.question
    this.temp_answer = this.q.ogrenci_cevap
    this.answer = this.q.ogrenci_cevap
    // ! this.answer && 
    if (localStorage.getItem(this.qkey + '_answers')) {

      let answer = JSON.parse(localStorage.getItem(this.qkey + '_answers'));
      this.answer = answer[this.index]

    }
    setTimeout(() => {
      if (this.$refs['img' + this.index] !== undefined && typeof this.$refs['img' + this.index].scrollWidth !== 'undefined') {
        
        let Atrament = this.$atrament; // eslint-disable-line
        let w = this.$refs['img' + this.index].scrollWidth
        let h = this.$refs['img' + this.index].scrollHeight
        this.draw_area[this.index] = new Atrament(document.querySelector('#canvas' + this.index), {
          width: w,
          height: h,
          smoothing: 0.4,
          adaptiveStroke: false,
          color: '#ff0000'
        });
      }
    }, 100);
  }
}

</script>
<style scoped>
.btn-group-toggle.special {
  display: flex;
}

.question_img {
  padding: 1em 2em;
  /*
  max-height: 450px;
  width: auto;
  display: block;
  margin: 0 auto;
  */
}
.special .btn {
  flex: 1
}

.btn-lg {
  font-size: 25px;
}

a.canvas_area {
  position: relative;
}
canvas {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.draw-area .btn-group {
  position: absolute;
  bottom: 7px;
  left: 7px;
}
.btn-group-toggle.special {
  display: flex;
  flex: 1;
}

.question_img {
  padding: 1em 2em;
  max-width: 800px;
  display: block;
  margin: 0 auto;
}
</style>